
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f5a14656&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./createCourse.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./createCourse.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f5a14656!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./createCourse.vue"),
  /* scopeId */
  "data-v-f5a14656",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onboarding/createCourse.vue
// module id = 2328
// module chunks = 61